// extracted by mini-css-extract-plugin
export default {"signatureField":"L91yi0","header":"LBxi4F","inputContainer":"ECD9_N"};